import { render, staticRenderFns } from "./UkrposhtaModule.vue?vue&type=template&id=52d8174e"
import script from "./UkrposhtaModule.vue?vue&type=script&lang=js"
export * from "./UkrposhtaModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports